<template>
  <div class="modalContainer">
    <div class="modal">
      <div class="errorModal">
        <h2>Error</h2>
        <p v-for="(error,index) in $store.state.ERRORS" :key="index">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
.errorModal {
  padding: 20px;
  display: grid;
  gap: 10px;
}
</style>